import { createAction } from '@ngrx/store';

export const appHydrated = createAction('NSIS_APP_HYDRATED');
